import { put, takeLatest, call } from 'redux-saga/effects'
import API from "store/login/loginApis";
import * as types from "store/login/loginTypes";
import auth from 'utils/auth'
import Storage from 'shared/helpers/storage'
import { parseJwt } from 'shared/helpers/functional'

export function* logout () {
  try {
    auth.signOut()
    yield put({ type: 'LOGOUT_SUCCEEDED' })
    Storage.clear()
  } catch (error) {
    yield put({
      type: 'ASYNC_FETCH_FAILED',
      nextActionType: 'LOGIN_FAILED',
      error,
    })
  }
}

 function* loginRequest({payload : payload}) {
  try {
    Storage.clear()
    const response =  yield call(API.loginRequest,payload);
    if (response.status === 203 ) {
      console.log("response ", response)
      const terms = response.data.termsAcceptedRes.body.terms
      yield put({type: 'POST_LOGIN_TERMS_NOT_ACCEPTED', terms: terms})
    }
    else if ( response.status === 200 ) {
      const id = response.data.body.userInfo.id 
      const accessToken =  response.data.body.accessToken
      Storage.setItem('accessToken', accessToken)
      Storage.setItem('x-api-key',response.data.apiKey)
      const tokenDecoded = parseJwt(accessToken)
      yield put({type:'POST_LOGIN_REQUEST_SUCCESSED', payload: response.data, roles: tokenDecoded['cognito:groups'], accountsSelected: response.data.body.userInfo.accountsSelected});
      console.log("user info ", response)
      yield put({type:'FETCH_USER_SUCCEEDED', payload: response.data.body.userInfo})
    } else {
      yield put({type:'POST_LOGIN_REQUEST_FAILED'})
    }
  } catch (err) {
      console.log("Login request failed: ",err);
      Storage.clear()
      yield put({type:'POST_LOGIN_REQUEST_FAILED', message: err.message})
    }
}

function* adminLoginRequest(resp) {
  try {
    Storage.clear()
    if ( resp.payload.statusCode === 200 ) {
      const idTokenDecoded = parseJwt(resp.payload.body.id_token)
      Storage.setItem('accessToken', resp.payload.body.id_token)
      Storage.setItem('x-api-key', process.env.REACT_APP_X_API_KEY)
      Storage.setItem('isIncrowdAdminLogin', true)
      yield put({type:'POST_ADMIN_LOGIN_REQUEST_SUCCEEDED', payload: resp.payload, roles: idTokenDecoded['cognito:groups'], accountsSelected: ""});
    } else {
      yield put({type:'POST_LOGIN_REQUEST_FAILED'})
    }
  } catch (err) {
      console.log("Admin Login request failed: ",err);
      Storage.clear()
      yield put({type:'POST_LOGIN_REQUEST_FAILED', message: err.message})
    }
}

function* updatePasswordRequest({ payload: payload }) {
  try {
    const response = yield call(API.updatePasswordRequest, payload);
    if (response.status === 200) {
      yield put({ type: 'POST_UPDATE_PASSWORD_SUCCESSED', status:response.status });
      if(payload.isForgetPassword){
        yield put({ type: 'CLOSE_RESET_PASSWORD_MODAL'});
        window.location.replace(window.location.origin + "/login")
      } 
    } else if (response.status === 400 || response.status === 403 || response.status === 401) {
      yield put({ type: 'POST_UPDATE_PASSWORD_FAILED', status:response.status})
    } else {
      yield put({ type: 'POST_UPDATE_PASSWORD_FAILED', status:response.status })
      yield put({ type: 'SHOW_MESSAGE', payload: { message: "Something went wrong please try again later",className: 'copy-screeners-snackbar'}})
      yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar'}})
    }
  } catch (err) {
    if (err.response.status === 401) {
      yield put({ type: 'POST_UPDATE_PASSWORD_FAILED', status:err.response.status})
    } else {
    console.log("update password request failed: ", err);
    yield put({ type: 'POST_UPDATE_PASSWORD_FAILED', message: err.message })
    yield put({ type: 'SHOW_MESSAGE', payload: { message: "There was a problem processing your request",className: 'copy-screeners-snackbar'}})
    yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar'}})
    }
  }
}


function* updateAccountSelection ({ payload }) {
  console.log("payload in update account saga ", payload)
  try {
    const response = yield call(API.updateAccountSelection, payload)
    console.log("response in updateAccountSelection ", response)
    if(response.status === 200) {
      yield put({type: 'UPDATE_ACCOUNT_SELECTION_SUCCEEDED', payload: response})
    }
  } catch (err) {
    console.log("error in getting clients for updated account ", err)
    yield put({ type: 'SHOW_MESSAGE', payload: { message: "There was a problem processing your request",className: 'copy-screeners-snackbar'}})
    yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar'}})
  }
}

function* watchIsI2andQsToolUser({ payload }) {
  try {
    const response = yield call(API.isI2andQsToolUser, payload)
    if (response.status === 200 && response.data.body.statusResult === 200) {
      yield put({ type: 'TOGGLE_I2_AND_QS_TOOL_USER_MODAL' })
      yield put({ type: 'IS_I2_AND_QS_TOOL_USER_SUCCESSED' })
    } else if (response.status === 200 && response.data.body.statusResult === 100) {
      yield put({ type: 'SEND_RESET_PASSWORD_EMAIL_REQUESTED', payload })
      yield put({ type: 'IS_I2_AND_QS_TOOL_USER_SUCCESSED' })

    } else if (response.status === 200 && response.data.body.error.code === 404) {
      yield put({ type: 'IS_I2_AND_QS_TOOL_USER_FAILED', status: response.status })
    } else {
      yield put({ type: 'IS_I2_AND_QS_TOOL_USER_FAILED' })
      yield put({ type: 'SHOW_MESSAGE', payload: { message: "Something went wrong please try again later", className: 'copy-screeners-snackbar' } })
      yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar' } })
    }
  } catch (err) {
    console.log("is I2 and Qs Tool user request failed: ", err);
    yield put({ type: 'IS_I2_AND_QS_TOOL_USER_FAILED', message: err.message })
    yield put({ type: 'SHOW_MESSAGE', payload: { message: "There was a problem processing your request", className: 'copy-screeners-snackbar' } })
    yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar' } })
  }
}

function* watchSendResetPasswordEmailRequest({ payload: payload }) {
  try {
    const response = yield call(API.sendResetPasswordEmailRequest, payload);
    if (response.status === 200) {
      yield put({ type: 'SEND_RESET_PASSWORD_EMAIL_SUCCESSED' });
    } else if (response.status === 404) {
      yield put({ type: 'SEND_RESET_PASSWORD_EMAIL_FAILED', status: response.status })
    } else {
      yield put({ type: 'SEND_RESET_PASSWORD_EMAIL_FAILED' })
      yield put({ type: 'SHOW_MESSAGE', payload: { message: "Something went wrong please try again later", className: 'copy-screeners-snackbar' } })
      yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar' } })
    }
    if (payload.closeModal) {
      yield put({ type: 'TOGGLE_I2_AND_QS_TOOL_USER_MODAL' })
    }
  } catch (err) {
    console.log("reset password request failed: ", err);
    yield put({ type: 'SEND_RESET_PASSWORD_EMAIL_FAILED', message: err.message })
    yield put({ type: 'SHOW_MESSAGE', payload: { message: "There was a problem processing your request", className: 'copy-screeners-snackbar' } })
    yield put({ type: 'HIDE_MESSAGE', payload: { className: 'copy-screeners-snackbar' } })
  }
}


export default function* watchLogin () {
  yield takeLatest('LOGOUT', logout)
  yield takeLatest(types.POST_LOGIN_REQUESTED, loginRequest)
  yield takeLatest(types.POST_ADMIN_LOGIN_REQUESTED, adminLoginRequest)
  yield takeLatest(types.POST_UPDATE_PASSWORD_REQUESTED, updatePasswordRequest)
  yield takeLatest(types.UPDATE_ACCOUNT_SELECTION, updateAccountSelection)
  yield takeLatest(types.SEND_RESET_PASSWORD_EMAIL_REQUESTED, watchSendResetPasswordEmailRequest)
  yield takeLatest(types.IS_I2_AND_QS_TOOL_USER_REQUESTED, watchIsI2andQsToolUser)
}
